import React from "react";
import { TMessage } from "../../../../../Types";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../../core/et3-ui/ET3Margin";
import Message from "./Message";

const Conversation = withLiteObserverAndTheme<{
  senderId: number;
  messages: TMessage[];
  reporterGender: string;
  reportedGender: string;
}>((props) => {
  const { messages, senderId, reporterGender, reportedGender, theme } = props;
  const { colors } = theme;
  const chat = messages.map((message: TMessage) => (
    <React.Fragment key={message.messageId}>
      <Message
        message={message}
        userId={senderId}
        reporterGender={reporterGender}
        reportedGender={reportedGender}
      />
      <Et3Margin top={10} bottom={10} right={0} left={0} />
    </React.Fragment>
  ));

  return (
    <ET3Div
      isScrollable={false}
      width={1120}
      height={500}
      color={colors.all.transparent}
      isExtendable={false}
      fDirection="column"
      justifyContent="center"
      alignItems="center"
      withShadow={false}
      style={{}}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={true}
        withShadow={false}
        isExtendable={false}
        width={1120}
        height={400}
        color={colors.all.white}
        fDirection="column"
        justifyContent="flex-start"
        alignItems="center"
        style={{
          border: `1px solid ${colors.all.lightGray}`,
          borderRadius: 40
        }}
        onClick={() => {}}
      >
        <Et3Margin top={10} bottom={10} right={0} left={0} />
        {chat}
      </ET3Div>
    </ET3Div>
  );
});

export default Conversation;
